import { WebsitePrimaryButton } from "@dev/ee-components";
import React from "react";
import { EmptyStateProps } from "./types";
import { ButtonContainer, CenteredTypography, SpacedTypography } from "./styles";

export const EmptyState = (props: EmptyStateProps) => {
    const { title, button, description} = props;

    return (
        <>
            <SpacedTypography variant="h3">
                {title}
            </SpacedTypography>
            <CenteredTypography variant="body1">
                {description}
            </CenteredTypography>
            <ButtonContainer>
                <WebsitePrimaryButton text={button.text} onClick={button.onClick}/>
            </ButtonContainer>
        </>
    )
}